import { Constants } from "appConstants";
import { IcoCheck, IcoError } from "assets/icons";
import { useCallback } from "react";
import { toast } from "react-toastify";

interface ToastReturn {
	showSuccessToast: (message?: string, title?: string) => void;
	showErrorToast: (message?: string, title?: string) => void;
}

function ToastMessage(title?: string, message?: string): JSX.Element {
	return (
		<div>
			{title && <h1>{title}</h1>}
			{message && <h3>{message}</h3>}
		</div>
	);
}

const useStandardToast = (): ToastReturn => {
	const showErrorToast = useCallback(
		(message?: string, title = Constants.strings.errors.error) =>
			toast.dark(ToastMessage(title, message), {
				icon: IcoError,
				position: "top-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: false,
				progress: undefined,
				theme: "dark",
				progressClassName: "progress-bar-custom-error"
			}),
		[]
	);

	const showSuccessToast = useCallback(
		(message?: string, title?: string) =>
			toast.dark(ToastMessage(title, message), {
				icon: IcoCheck,
				position: "top-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: false,
				progress: undefined,
				theme: "dark",
				progressClassName: "progress-bar-custom-sucess"
			}),
		[]
	);

	return {
		showSuccessToast,
		showErrorToast
	};
};

export default useStandardToast;
